var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCountry = function SvgCountry(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "organizacion",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.99 18.57",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a9a9a9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-flag-3405703"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5456",
    className: "cls-1",
    d: "m6.17,13.43v1.21c1.07.27,1.75.78,1.75,1.27,0,.68-1.4,1.46-3.27,1.46s-3.27-.76-3.27-1.46c0-.49.7-1.01,1.75-1.27v-1.21c-1.73.35-2.92,1.3-2.92,2.47,0,1.5,1.91,2.63,4.44,2.63s4.44-1.13,4.44-2.63c0-1.17-1.19-2.12-2.92-2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5457",
    className: "cls-1",
    d: "m11.19,1.44h-5.96v-.82c0-.32-.26-.58-.58-.58s-.58.26-.58.58h0v14.91c0,.32.26.58.58.58s.58-.26.58-.58V7.34h5.96c.32,0,.58-.25.58-.57,0,0,0,0,0-.01V2.02c0-.32-.25-.58-.57-.58,0,0,0,0-.01,0Zm-.58,4.73h-5.37v-3.56h5.37v3.56Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCountry);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "country.fc8dc8d8ea7fc7c6e259ef80e2adbe38.svg";